import React from 'react';
import '../styles/scrollbar.css'

const ScrollElement = ({ children, className }) => {
    return (
        <div className={`${className} scrollbar-wrapper`}>{children}</div>
    )
}
export default ScrollElement;